var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector3Mob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 201,
    viewBox: "0 0 390 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-63 199C-47.9283 161.825 12.8026 104.136 135.153 170.78C257.504 237.423 398.697 86.028 454 2",
    stroke: "url(#paint0_linear_16_117)",
    strokeOpacity: 0.13,
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_117",
    x1: 454,
    y1: 2.4693,
    x2: -63,
    y2: 2.46928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#C0B7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#8176AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343045"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3Mob);
export default __webpack_public_path__ + "static/media/vector3-mob.5954b1556ca276c853e44322640e33ec.svg";
export { ForwardRef as ReactComponent };